import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_2 = { class: "flex flex-col w-full text-black" }
const _hoisted_3 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_4 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_5 = { class: "font-semibold text-white text-sm md:text-xl truncate whitespace-nowrap overflow-hidden text-ellipsis flex flex-col" }
const _hoisted_6 = { class: "tracking-wider" }
const _hoisted_7 = { class: "container p-4 text-left space-y-3" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2" }
const _hoisted_9 = { class: "flex flex-col -mx-2 text-lg uppercase space-y-1" }
const _hoisted_10 = {
  key: 0,
  class: "mx-auto"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  class: "w-16 h-16 flex-shrink-0 rounded-lg border border-[#424c42] flex items-center justify-center font-semibold text-xl text-gray-700 bg-[radial-gradient(circle,_white_0%,_#d1d5db_100%)]"
}
const _hoisted_13 = { class: "leading-none text-gray-500 mb-1 text-xl" }
const _hoisted_14 = {
  key: 1,
  class: "w-full text-center text-xl"
}
const _hoisted_15 = {
  key: 2,
  class: "w-full text-center text-xs text-gray-500 pt-2"
}
const _hoisted_16 = {
  key: 3,
  class: "w-full text-center text-sm text-gray-600"
}
const _hoisted_17 = {
  key: 4,
  class: "w-full text-center text-sm text-gray-600 pt-2"
}
const _hoisted_18 = {
  key: 5,
  class: "w-full text-center text-sm text-gray-600 pt-2"
}
const _hoisted_19 = {
  key: 6,
  class: "w-full text-center text-xs text-gray-500 pt-2"
}
const _hoisted_20 = { class: "w-full text-center text-lg text-gray-600 line-clamp-2" }
const _hoisted_21 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "fixed inset-0 z-50 overflow-y-auto bg-black/60 flex justify-center p-2 sm:p-5",
      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
    }, [
      _createElementVNode("div", {
        class: "w-full md:w-8/12 lg:w-4/12 xl:w-5/12 my-auto",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-lock'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }, " AGENDA ", -1)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.detalleAgenda.cronograma.fecha, 'dd/MM/yyyy')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.detalleAgenda.cronograma.horaDesde), 1)
                  ])
                ]),
                _createVNode(_component_Form, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          class: "w-full text-white px-2 py-2 text-center rounded-lg shadow-sm uppercase text-lg",
                          style: _normalizeStyle({ backgroundColor: _ctx.detalleAgenda.colorEstado })
                        }, _toDisplayString(_ctx.detalleAgenda.descripcionEstado), 5)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (_ctx.detalleAgenda.contraparte)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (_ctx.detalleAgenda.contraparte.foto)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.detalleAgenda.contraparte.foto,
                                    class: "w-24 h-24 flex-shrink-0 rounded-lg border border-[#424c42] object-cover"
                                  }, null, 8, _hoisted_11))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.iniciales(_ctx.detalleAgenda.contraparte.nombre, _ctx.detalleAgenda.contraparte.apellido)), 1)
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.detalleAgenda.contraparte)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.detalleAgenda.contraparte?.nombre + " " + _ctx.detalleAgenda.contraparte?.apellido), 1))
                          : _createCommentVNode("", true),
                        (_ctx.detalleAgenda.empresa)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Empresa"))
                          : _createCommentVNode("", true),
                        (_ctx.detalleAgenda.empresa)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.detalleAgenda.empresa?.nombreFantasia || _ctx.detalleAgenda.empresa?.razonSocial || 'Sin empresa'), 1))
                          : _createCommentVNode("", true),
                        (_ctx.detalleAgenda.empresa?.pabellon)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Pabellón : " + _toDisplayString(_ctx.detalleAgenda.empresa?.pabellon), 1))
                          : _createCommentVNode("", true),
                        (_ctx.detalleAgenda.empresa?.stand)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Stand : " + _toDisplayString(_ctx.detalleAgenda.empresa?.stand), 1))
                          : _createCommentVNode("", true),
                        (_ctx.detalleAgenda.observaciones)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Observaciones"))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.detalleAgenda.observaciones), 1)
                      ]),
                      _createVNode(_component_Field, {
                        name: "motivoCambioEstado",
                        modelValue: _ctx.motivoCambioEstado,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.motivoCambioEstado) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_Textarea, _mergeProps(field, {
                            rows: "4",
                            type: "text",
                            placeholder: _ctx.$t('label.motivo.cambio.estado'),
                            class: ["input-base w-full border border-gray-300 p-2 text-gray-500 !shadow-md rounded-xl mt-4", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0 }]
                          }), null, 16, ["placeholder", "class"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.puedeCancelar)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelar())),
                        class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['far', 'fa-bell-slash'] }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar.solicitud')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.puedeRechazar)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.rechazar())),
                        class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-ban'] }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.rechazar')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.puedeConfirmar)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmar())),
                        class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check'] }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.confirmar')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.puedeDesbloquear)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.desbloquear())),
                        class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-lock-open'] }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.desbloquear')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeDialog(false))),
                    class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cerrar')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}